<p-blockUI [blocked]="blockThisUI">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>
